var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMatterFilled = function SvgIconMatterFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27782 4.18182L6.61115 2H1.88893C1.74159 2 1.60028 2.05747 1.49609 2.15976C1.39191 2.26205 1.33337 2.40079 1.33337 2.54545V12.3636C1.33337 12.7976 1.50897 13.2138 1.82153 13.5207C2.13409 13.8276 2.55801 14 3.00004 14H13C13.4421 14 13.866 13.8276 14.1786 13.5207C14.4911 13.2138 14.6667 12.7976 14.6667 12.3636V4.72727C14.6667 4.58261 14.6082 4.44387 14.504 4.34158C14.3998 4.23929 14.2585 4.18182 14.1112 4.18182H8.27782Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMatterFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconMatterFilled.1000b03b.svg";
export { ForwardRef as ReactComponent };